import Flickity from 'flickity';

const carousels = [];

export default function () {
  document.querySelectorAll('[data-article-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }
    if (el.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new Flickity(el, {});

    carousels.push(carousel);
  });
}
